const config = {
  // apiUrl: 'https://api.influence.intesols.com.au/api/v1/',
  // apiUrl: 'https://732b-103-216-83-50.in.ngrok.io/client/influence/api/v1/'
  apiUrl: 'https://api.influencepartners.com.au/api/v1/'
  // apiUrl: 'https://dfb9-103-216-83-50.in.ngrok.io/api/v1/'
};

export default config;
